<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path d="M1 3.625C1 2.17525 2.17525 1 3.625 1H12.375C13.8247 1 15 2.17525 15 3.625V12.375C15 13.8247 13.8247 15 12.375 15H3.625C2.17525 15 1 13.8247 1 12.375V3.625Z" stroke="#060606" stroke-opacity="0.8" stroke-width="1.5"/>
    </svg>
</template>

